import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { queryStatement } from "./services";

export function statementLoader() {
  return defer({
    coreData: resolveLoaderResult(queryStatement()),
  });
}
